"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var Speedometer = function Speedometer(_ref) {
  var name = _ref.name,
    fill = _ref.fill,
    className = _ref.className,
    title = _ref.title;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    className: "icon icon-no-fill ".concat(className),
    xmlns: "http://www.w3.org/2000/svg",
    version: "1.1",
    viewBox: "0 0 24 24",
    height: "24",
    width: "24"
  }, /*#__PURE__*/_react["default"].createElement("title", null, title || name), /*#__PURE__*/_react["default"].createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M 9,15.292v-0.285c0-1.657,1.343-3,3-3s3,1.343,3,3v0.285 ",
    stroke: fill,
    fill: "none",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M 14.252,5.257l-2.25,6.75 ",
    stroke: fill,
    fill: "none",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M 6.377,7.507 c-0.207,0-0.375,0.168-0.375,0.375S6.17,8.257,6.377,8.257s0.375-0.168,0.375-0.375l0,0C6.752,7.675,6.584,7.507,6.377,7.507 L6.377,7.507 ",
    stroke: fill,
    fill: "none",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M 19.127,11.257c-0.207,0-0.375,0.168-0.375,0.375s0.168,0.375,0.375,0.375s0.375-0.168,0.375-0.375 S19.334,11.257,19.127,11.257L19.127,11.257 ",
    stroke: fill,
    fill: "none",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M 17.627,7.507C17.42,7.506,17.251,7.673,17.25,7.88 c-0.001,0.207,0.166,0.376,0.373,0.377C17.83,8.258,17.999,8.091,18,7.884c0-0.001,0-0.001,0-0.002 c0-0.207-0.168-0.375-0.375-0.375l0,0 ",
    stroke: fill,
    fill: "none",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M 9.377,4.507c-0.207,0-0.375,0.168-0.375,0.375S9.17,5.257,9.377,5.257 s0.375-0.168,0.375-0.375S9.584,4.507,9.377,4.507L9.377,4.507 ",
    stroke: fill,
    fill: "none",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M 21.431,18.142c-5.593-4.18-13.269-4.18-18.862,0 ",
    stroke: fill,
    fill: "none",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M 12,0.757 c6.213,0,11.25,5.037,11.25,11.25S18.213,23.257,12,23.257S0.75,18.22,0.75,12.007S5.787,0.757,12,0.757z ",
    stroke: fill,
    fill: "none",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M 4.877,11.257 c-0.207,0-0.375,0.168-0.375,0.375s0.168,0.375,0.375,0.375s0.375-0.168,0.375-0.375S5.084,11.257,4.877,11.257",
    stroke: fill,
    fill: "none",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
Speedometer.propTypes = {
  name: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string,
  fill: _propTypes["default"].string,
  className: _propTypes["default"].string
};
Speedometer.defaultProps = {
  fill: '#ffffff',
  className: ''
};
var _default = exports["default"] = Speedometer;